import { render, staticRenderFns } from "./FullWidthNotice.vue?vue&type=template&id=22c2b060&scoped=true"
import script from "./FullWidthNotice.vue?vue&type=script&lang=js"
export * from "./FullWidthNotice.vue?vue&type=script&lang=js"
import style0 from "./FullWidthNotice.vue?vue&type=style&index=0&id=22c2b060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c2b060",
  null
  
)

export default component.exports